import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'

export const Container = styled.div`
  background-color: #FFFFFF;
  width: 100%;
  margin: 0px 0px 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 5px 12px 12px;
  gap: 10px;

  &:hover {
    background-color: #FCFCFC;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 5px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const Button = styled(LookButton).attrs(iconButtonLook())`
  width: 32px;
  height: 32px;
`
